import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { InputScannerConfig } from '@core/models/built/procedure-step-config.model';
import { ProcedureStep } from '@core/models/procedures.model';
import { FlowchartMode } from '@flowchart';
import { TranslocoService } from '@ngneat/transloco';
import { BarcodeFormat } from '@zxing/library';
import { BehaviorSubject } from 'rxjs';
import { arrayMinLength } from 'src/app/utils/form-validators/array-min-length.validator';

import it from './i18n/input-scanner-edit.it.json';

@Component({
  templateUrl: './input-scanner-edit.component.html'
})
export class InputScannerEditComponent implements OnInit, OnDestroy {
  @Input() step?: ProcedureStep;
  @Input() mode: FlowchartMode = 'edit';
  @Input() editForm!: FormGroup;

  private barcodeTypes$$ = new BehaviorSubject<string[]>([]);
  barcodeTypes$ = this.barcodeTypes$$.asObservable();

  allBarcodeTypes: string[] = Object.keys(BarcodeFormat).reduce((acc, curr) => {
    // eslint-disable-next-line radix
    if (isNaN(parseInt(curr))) {
      acc = [...acc, curr];
    }
    return acc;
  }, [] as string[]);

  constructor(
    private fb: FormBuilder,
    private translocoSvc: TranslocoService
  ) {
    this.translocoSvc.setTranslation(it, 'it');
  }

  ngOnInit() {
    const config = this.step?.config as InputScannerConfig;

    const configGroup = (this.editForm.get('config') as FormGroup);
    if (configGroup) {
      configGroup.addControl('barcodeTypes', this.fb.control(config?.barcodeTypes || [], [arrayMinLength(1)]));
    } else {
      this.editForm.addControl('config', this.fb.group({
        barcodeTypes: this.fb.control(config?.barcodeTypes || [], [arrayMinLength(1)])
      }));
    }

    this.barcodeTypes$$.next(config?.barcodeTypes || []);

    if (this.mode === 'view') {
      (this.editForm.get('config') as FormGroup).disable();
    }
  }

  ngOnDestroy() {
    const configGroup = (this.editForm.get('config') as FormGroup);
    if (configGroup) {
      configGroup.removeControl('barcodeTypes');

      if (Object.keys(configGroup.controls).length <= 0) {
        this.editForm.removeControl('config');
      }
    }
  }

  addBarcodeType(evt: any, value?: string) {
    evt.stopPropagation();
    if (value && typeof value === 'string') {
      const barcodeTypes: string[] = [...new Set([...this.barcodeTypes$$.getValue(), value])];
      this.barcodeTypes$$.next(barcodeTypes);
      (this.editForm.get('config.barcodeTypes') as FormControl).setValue(barcodeTypes);
    }
  }

  removeBarcodeType(value: string) {
    const barcodeTypes: string[] = this.barcodeTypes$$.getValue().filter(a => a !== value);
    this.barcodeTypes$$.next(barcodeTypes);
    const ctl = (this.editForm.get('config.barcodeTypes') as FormControl);
    ctl.setValue(barcodeTypes);
    ctl.markAsTouched();
  }
}
